{
  "account-existed-dialog": {
    "buttons": {
      "cancel": "Annuler",
      "login": "Connexion"
    },
    "text": {
      "title": "Il existe déjà un compte avec cet email : {{ email }} ou numéro de téléphone : {{ phoneNr }}",
      "title-email-exists": "Il existe déjà un compte avec cet email : {{ email }}",
      "title-phone-exists": "Il existe déjà un compte avec ce numéro de téléphone : {{ phoneNr }}",
      "hint": "Vous pouvez vous connecter directement avec cet email/numéro de téléphone ou utiliser un autre email/numéro de téléphone pour vous inscrire.",
      "hint-email-exists": "Vous pouvez vous connecter directement avec cet email ou utiliser un autre email pour vous inscrire.",
      "hint-phone-exists": "Vous pouvez vous connecter directement avec ce numéro de téléphone ou utiliser un autre numéro de téléphone pour vous enregistrer."
    }
  }
}
